import { render } from "./ButtonWithConfirm.vue?vue&type=template&id=5e496e9c"
import script from "./ButtonWithConfirm.vue?vue&type=script&lang=js"
export * from "./ButtonWithConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__